var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refund-status-wrapper"},[_c('img',{attrs:{"src":require("@/assets/images/success1.png"),"width":"130"}}),_c('div',{staticClass:"status"},[_vm._v("Success")]),_c('div',{staticClass:"tip"},[_vm._v("Your refund application has been submitted successfully, and we will process it as soon as possible")])])
}]

export { render, staticRenderFns }